module.exports = __webpack_public_path__ + "static/img/lifestyle_32.05395bd8.png";